<template>
  <div>
    <v-dialog max-width="50%" v-model="computed_dialog">
      <app-card>
        <h4>UPLOAD SAO KÊ NGÂN HÀNG</h4>
        <v-form ref="form">
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 v-if="!isBidvWallet">
                <v-btn @click="downloadTemplate(BANK_LIST.VCB)" color="blue" dark
                  >Tải template VCB</v-btn
                >
              </v-flex>
              <v-flex xs12 md12>
                <i v-if="isBidvWallet">
                  Tải file sao kê (.xlsx) trực tiếp từ BIDV SmartBanking về và tải lên trực tiếp, không cần chỉnh sửa.
                </i>
                <i v-else>
                  Vui lòng tải xuống template và điền thông tin theo mẫu.
                </i>
              </v-flex>
              <v-flex xs12 md12 class="my-2">
                <div>Chọn file để tải lên</div>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileChange"
                  accept=".xlsx"
                  required
                />
              </v-flex>
              <v-flex xs12 v-if="isBidvWallet">
                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  label="Mật khẩu mở file sao kê (nếu có)"
                  prepend-icon="lock"
                  hint="Nhập mật khẩu mở file sao kê nếu file BIDV được đặt mật khẩu"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="alert.show">
                <v-alert :value="alert.show" :type="alert.type" outline>
                  {{ alert.text }}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loading.submit"
              :disabled="loading.submit || alert.show"
              @click="submit"
              color="green"
              class="white--text"
            >
              Upload
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-card>
    </v-dialog>
  </div>
</template>

<script>
import AppConfig from "Constants/AppConfig";
import { BANK_LIST, WALLET_ID_AND_ACCOUNT_TYPE_MAP } from "Constants/db-config";

export default {
  name: "dialog-upload-sao-ke",
  props: {
    dialog: Boolean,
    chosen_wallet_account_id: Number,
  },
  data() {
    return {
      computed_dialog: false,
      selectedFile: null,
      password: "",
      showPassword: false,
      loading: {
        submit: false,
      },
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      BANK_LIST,
    };
  },
  computed: {
    isBidvWallet() {
      const accountName =
        WALLET_ID_AND_ACCOUNT_TYPE_MAP[this.chosen_wallet_account_id] || "";
      return accountName.includes("BIDV");
    },
  },
  watch: {
    computed_dialog(nv) {
      this.$emit("changeDialogState", nv);
      if (!nv) this.clearInput();
    },
    dialog(nv) {
      this.computed_dialog = nv;
    },
  },
  methods: {
    clearInput: function() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.selectedFile = null;
      this.password = "";
      this.showPassword = false;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    async downloadTemplate(bank) {
      try {
        const response = await fetch(
          `${AppConfig.host}/api/bank-transactions/download-template?bank=${bank}`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.$store.state.auth.token,
            },
          }
        );

        if (!response.ok) {
          swal.fire("Lỗi khi tải về mẫu");
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${bank}_template.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        swal.fire("Đã xảy ra lỗi khi tải về mẫu");
      }
    },
    submit: async function() {
      if (!this.selectedFile) {
        swal.fire("Vui lòng chọn một tệp.");
        return;
      }

      this.loading.submit = true;

      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("wallet_account_id", this.chosen_wallet_account_id);
      if (this.password) {
        formData.append("password", this.password);
      }

      try {
        const response = await fetch(
          `${AppConfig.host}/api/bank-transactions/upload-file`,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: "Bearer " + this.$store.state.auth.token,
            },
          }
        );
        this.loading.submit = false;

        if (response.ok) {
          this.computed_dialog = false;
          swal.fire("Tệp đã được xử lý thành công!");
          this.$emit("reloadTable");
        } else {
          const error = await response.json();
          swal.fire(`Đã xảy ra lỗi khi xử lý tệp.
${error.message}`);
        }
        this.clearInput();
      } catch (error) {
        this.clearInput();
        swal.fire("Đã xảy ra lỗi khi xử lý tệp.");
      }
    },
  },
};
</script>

<style></style>

